import * as React from 'react';
import { FC, SVGProps } from 'react';

export const ChevronRightIcon: FC<SVGProps<SVGSVGElement>> = props => (
    <svg
        width={17}
        height={14}
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0.535889 6.73041L15.5359 6.73041M15.5359 6.73041L9.11979 12.7304M15.5359 6.73041L9.11979 0.730408"
            stroke="currentColor"
            strokeWidth={2}
        />
    </svg>
);

export default ChevronRightIcon;
